var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container footer-text"},[_c('span',[_vm._v("\n      Learning ECO system."),_c('br'),_vm._v("\n      © Cambridge Technology Partners Limited.\n    ")])])])
}]

export { render, staticRenderFns }